import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import SortableHeader from "../../../../components/atoms/SortableHeader";
import { getVarsomeHost } from "../../../../state/selectors/general.selectors";
import { compareByProperty } from "./helpers";
import GeneWithRefGenomeLink from "../../../../common/helpers/GeneWithRefGenomeLink";

const labels = {
  fusion_symbol: "Fusion Symbol",
  to_gene_symbol: "To Gene Symbol",
  from_gene_symbol: "From Gene Symbol",
};

function FusionGdbGenesTable({
  items,
  sortedField,
  isAsc,
  toggleField,
  varsomeHost,
}) {
  return (
    <div className="tw-overflow-y-auto tw-ml-0 tw-mb-8">
      <table className="varsome-table varsome-table-sorted ">
        <thead>
          <tr>
            <SortableHeader
              sort={(key) => toggleField(compareByProperty(key), key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="fusion_symbol"
              width="30%"
            />
            <SortableHeader
              sort={(key) => toggleField(compareByProperty(key), key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="from_gene_symbol"
              width="35%"
            />
            <SortableHeader
              sort={(key) => toggleField(compareByProperty(key), key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="to_gene_symbol"
              width="35%"
            />
          </tr>
        </thead>
        <tbody>
          {items.map((x) => {
            return (
              <tr key={x.fusion_symbol}>
                <td>{x.fusion_symbol}</td>
                <td>
                  <GeneWithRefGenomeLink
                    target="_blank"
                    href={`${varsomeHost}/gene/${x.from_gene_symbol}`}
                  >
                    {x.from_gene_symbol}
                  </GeneWithRefGenomeLink>
                </td>
                <td>
                  <GeneWithRefGenomeLink
                    target="_blank"
                    href={`${varsomeHost}/gene/${x.to_gene_symbol}`}
                  >
                    {x.to_gene_symbol}
                  </GeneWithRefGenomeLink>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

FusionGdbGenesTable.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      fusion_symbol: PropTypes.string,
      to_gene_symbol: PropTypes.string,
      from_gene_symbol: PropTypes.string,
    })
  ),
  sortedField: PropTypes.string,
  isAsc: PropTypes.bool,
  toggleField: PropTypes.func.isRequired,
  varsomeHost: PropTypes.string,
};

FusionGdbGenesTable.defaultProps = {
  items: null,
  sortedField: null,
  isAsc: true,
  varsomeHost: null,
};

const mapStateToProps = (state) => ({
  varsomeHost: getVarsomeHost(state),
});

export default connect(mapStateToProps, null)(FusionGdbGenesTable);
